// @flow

import React from "react";
import { localize } from "redux-i18n";

import { formatDateTime } from "@transformers/date";
import type { SelectedTask } from "@modules/reporting/reducer/tasks/types";

type OwnProps = $Exact<{
  selectedTask: SelectedTask,
}>;

type Props = $Exact<{
  ...PropsFromLocalize,
  ...OwnProps,
}>;

export const RTWTaskDetailsViewSection = (props: Props) => (
  <div className="w-100">
    <div className="d-flex small-font-size justify-content-between mb-2">
      <div className="w-50 with-border pt-2 mr-2">{props.t("TASK_ID")}:</div>
      <div className="w-50 with-border pt-2">{props.selectedTask.id || props.t("N/A")}</div>
    </div>
    <div className="d-flex small-font-size justify-content-between">
      <div className="w-50 with-border pt-2 mr-2">{props.t("DUE_DATE")}:</div>
      <div className="w-50 with-border pt-2 text-pumpkin-orange font-weight-bold">
        {props.selectedTask.dueDate ? formatDateTime(props.selectedTask.dueDate) : props.t("N/A")}
      </div>
    </div>
  </div>
);

export default localize()(RTWTaskDetailsViewSection);
